let navigator;

export const setNavigator = (nav) => {
  navigator = nav;
};

export const goBack = () => {
  if (navigator) {
    navigator(-1);
  } else {
    console.warn("Navigator not set");
  }
};
